module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA4.c1f64a40.jpg";